import {useDebugValue} from 'react';
import {BaseCurrencyCode} from '~/library/types';
import {useAppSelector} from '~/shared/store';
import {asCurrency, Currency, CurrencyTrait} from './Currency';

export function useConversionRate({
    from,
    to,
}: {
    from: BaseCurrencyCode | Currency | CurrencyTrait;
    to: BaseCurrencyCode | Currency | CurrencyTrait;
}) {
    if (typeof from !== 'string') {
        from = asCurrency(from).code;
    }
    if (typeof to !== 'string') {
        to = asCurrency(to).code;
    }

    // TODO: implicit violation of FSD, rework organization
    const rates = useAppSelector(state => state.assets.assets?.currencies);

    let coefficient = rates?.[to]?.[from];
    if (coefficient == null) {
        coefficient = 0;
    }
    useDebugValue(coefficient);
    return coefficient;
}
